/* helper function to access isEnabled in websocketSlice */

let isEnabled = false;

export const setIsEnabledGlobal = (enabled) => {
    isEnabled = enabled;
};

export const getIsEnabledGlobal = () => {
    return isEnabled;
};